import React from 'react';
import { Box, ButtonBase, Paper, Radio, Typography } from '@mui/material';
import { tasksPageText } from '../constants.ts';
import { tasksPageStyles } from '../styles.ts';
import { getTaskRoleLabel } from '../utils.ts';
import type { TTaskRoleKey } from '../types.ts';

interface ITaskRoleFilterProps {
  availableRoles: TTaskRoleKey[];
  selectedRole: TTaskRoleKey | '';
  onSelectRole: (role: TTaskRoleKey) => void;
}

const TaskRoleFilter: React.FC<ITaskRoleFilterProps> = ({
  availableRoles,
  selectedRole,
  onSelectRole,
}) => {
  const isSingleRole = availableRoles.length === 1;

  return (
    <Paper elevation={0} variant="outlined" sx={tasksPageStyles.rolePanel}>
      <Box sx={tasksPageStyles.rolePanelHeader}>
        <Typography variant="subtitle1" sx={tasksPageStyles.rolePanelTitle}>
          {tasksPageText.roleFilterTitle}
        </Typography>
      </Box>

      <Box sx={tasksPageStyles.roleList} role="radiogroup">
        {availableRoles.map((role) => {
          const isSelected = selectedRole === role;

          return (
            <ButtonBase
              key={role}
              disabled={isSingleRole}
              onClick={() => onSelectRole(role)}
              sx={tasksPageStyles.roleItem(isSelected)}
              role="radio"
              aria-checked={isSelected}
            >
              <Radio
                checked={isSelected}
                disabled={isSingleRole}
                size="small"
                tabIndex={-1}
                disableRipple
                sx={tasksPageStyles.roleRadio}
              />
              <Box sx={tasksPageStyles.roleTextWrap}>
                <Typography component="span" sx={tasksPageStyles.roleLabel}>
                  {getTaskRoleLabel(role)}
                </Typography>
              </Box>
            </ButtonBase>
          );
        })}
      </Box>
    </Paper>
  );
};

export default TaskRoleFilter;
